import { format } from 'date-fns';

import { CS_API_ROLES } from '../../constants/roles';
import apiRequestActionCreator from '../apiRequestActionCreator';
import {
    addItem,
    deleteItem,
    emptyCollection,
    fetchCollection,
    fetchItem,
    processItemError,
    updateItem,
} from '../collectionActions';

const paramsFunction = ({ params }) => ({
    ...params,
    handoverDate: params.handoverDate && format(new Date(params.handoverDate), 'yyyy-MM-dd'),
    leftFromFactoryDate:
        params.leftFromFactoryDate && format(new Date(params.leftFromFactoryDate), 'yyyy-MM-dd'),
    liveDate: params.liveDate && format(new Date(params.liveDate), 'yyyy-MM-dd'),
    serviceHours: params.serviceHours
        ? params.serviceHours.reduce(
              (acc, curr) =>
                  curr.startTime && curr.endTime && curr.weekdayIndexes
                      ? [
                            ...acc,
                            {
                                ...curr,
                                endTime: format(curr.endTime, 'HH:mm'),
                                startTime: format(curr.startTime, 'HH:mm'),
                            },
                        ]
                      : acc,
              []
          )
        : [],
    warranty: {
        ...params.warranty,
        warrantyEndDate:
            params.warranty?.warrantyEndDate &&
            format(new Date(params.warranty.warrantyEndDate), 'yyyy-MM-dd'),
    },
});

const fetchApms = fetchCollection({
    apiCollectionName: 'apms',
    collectionActionName: 'APMS',
    paramsFunction: ({ params }) => ({ orderBy: 'id', ...params }),
});

const emptyApms = emptyCollection({
    collectionActionName: 'APMS',
});

const addApm = addItem({
    apiCollectionName: 'apms',
    itemActionName: 'APM',
    paramsFunction,
});

const fetchApm = fetchItem({
    apiCollectionName: 'apms',
    itemActionName: 'APM',
});

const fetchApmBySerial = serial =>
    apiRequestActionCreator({
        actionName: 'APM_BY_SERIAL',
        actionParams: { serial },
        params: {
            params: { serial },
            url: 'apms/serial',
        },
    });

const updateApm = updateItem({
    apiCollectionName: 'apms',
    itemActionName: 'APM',
    paramsFunction,
});

const deleteApm = deleteItem({
    apiCollectionName: 'apms',
    itemActionName: 'APM',
});

const updateApmEnvironment = updateItem({
    apiCollectionName: 'apms/environment',
    itemActionName: 'APM_ENVIRONMENT',
});

const updateApmStatus = ({ apmId, ...data }) =>
    apiRequestActionCreator({
        actionName: 'APM_STATUS_UPDATE',
        actionParams: {
            apmId,
        },
        params: {
            data,
            method: 'put',
            url: `apms/${apmId}/status`,
        },
    });

const updateApmUsability = ({ apmId, ...data }) =>
    apiRequestActionCreator({
        actionName: 'APM_USABILITY_UPDATE',
        actionParams: {
            apmId,
        },
        params: {
            data,
            method: 'put',
            url: `apms/${apmId}/usability`,
        },
        processError: error => processItemError({ error }),
    });

export {
    addApm,
    deleteApm,
    emptyApms,
    fetchApm,
    fetchApmBySerial,
    fetchApms,
    updateApm,
    updateApmEnvironment,
    updateApmStatus,
    updateApmUsability,
};

export const apmsPermissions = {
    fetchApms: CS_API_ROLES.APM_READ,
};
